/**
 * API response normalization for admin pages.
 * Prevents crashes when backend returns unexpected shapes (404, 500, or different formats).
 */

/**
 * Normalize list API response to array. Safe for .map(), .filter(), etc.
 * Handles: [], { data: [] }, { items: [] }, { users: [] }, null, undefined
 */
export function toList(resData) {
  if (Array.isArray(resData)) return resData;
  if (!resData || typeof resData !== "object") return [];
  return (
    resData.data ??
    resData.items ??
    resData.users ??
    resData.contacts ??
    resData.feedback ??
    resData.advertising ??
    []
  );
}

/**
 * Ensure value is an array. Fallback to [].
 */
export function ensureArray(val) {
  return Array.isArray(val) ? val : [];
}
